import e from "react";
import O from "./index130.mjs";
import R from "./index131.mjs";
import G from "./index132.mjs";
import L from "./index133.mjs";
import n from "./index134.mjs";
import { Column as C } from "./index135.mjs";
import { CapacityBanner as P } from "./index114.mjs";
import { cartItemsAtom as B, giftCardsAtom as F, roomsAvailabilityAtom as N } from "./index34.mjs";
import { totalAdultsAtom as x, totalChildrenAtom as K } from "./index26.mjs";
import { setSelectedGiftCardAtom as V } from "./index64.mjs";
import { useAtomValue as d, useSetAtom as z } from "jotai";
import { useRemoveCart as b } from "./index101.mjs";
import { useHotelConfig as H } from "./index93.mjs";
import { formatPrice as _ } from "./index110.mjs";
import { getSubscriptionPlanRoot as W } from "./index14.mjs";
import { track as Y } from "./index9.mjs";
import { TRACK_EVENT_TYPE as j, TRACK_EVENT as q } from "./index10.mjs";
import { getDaysDifference as J } from "@amenitiz/design-system";
import Q from "classnames";
const T = {
  month: "short",
  day: "2-digit",
  weekday: "short",
  year: "numeric"
}, S = ({ children: t }) => /* @__PURE__ */ e.createElement("div", { className: n["cart-item"], "data-testid": "cart-item" }, t), I = ({ dataTestId: t, children: a }) => /* @__PURE__ */ e.createElement("div", { className: n.row, "data-testid": t }, a), y = ({ dataTestId: t, children: a }) => /* @__PURE__ */ e.createElement("div", { className: n.price, "data-testid": t }, a), A = ({ onClick: t }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "remove-cart-item",
    className: n.remove,
    onClick: t
  },
  /* @__PURE__ */ e.createElement(G, null),
  /* @__PURE__ */ e.createElement("span", null, I18n.t("booking_engine.information.remove"))
), D = ({ title: t }) => /* @__PURE__ */ e.createElement("h4", { className: n["header-title"], "data-testid": "cart-title" }, t), U = ({
  displaysInsideModal: t,
  cartItems: a,
  totalAdults: i,
  totalChildren: s,
  checkInTime: c,
  checkInEndTime: m,
  checkOutTime: r,
  checkOutEndTime: p,
  checkInInfo: l,
  showCheckInCheckOutTime: E
}) => {
  var g, h, k;
  return /* @__PURE__ */ e.createElement("div", { className: n["expanded-header"] }, t ? null : /* @__PURE__ */ e.createElement(D, { title: I18n.t("booking_engine.room.room_stay") }), /* @__PURE__ */ e.createElement("div", { className: n["dates-container"] }, /* @__PURE__ */ e.createElement(R, null), /* @__PURE__ */ e.createElement(
    C,
    {
      title: I18n.t("booking_engine.room.check_in"),
      value: ((g = a[0]) == null ? void 0 : g.arrivalDate.toLocaleDateString(
        window.I18n.locale,
        T
      )) ?? "",
      description: E ? `${c} - ${m}` : null,
      classes: n["check-in"],
      valueStyle: n.check_in_value,
      dataTestId: "check-in-time",
      titleId: "arrivalDateLabel"
    }
  ), /* @__PURE__ */ e.createElement(
    C,
    {
      title: I18n.t("booking_engine.room.check_out"),
      value: ((h = a[0]) == null ? void 0 : h.departureDate.toLocaleDateString(
        window.I18n.locale,
        T
      )) ?? "",
      description: E ? `${r} - ${p}` : null,
      classes: n["check-out"],
      valueStyle: n.check_in_value,
      dataTestId: "check-out-time"
    }
  )), l ? /* @__PURE__ */ e.createElement("div", { className: n["check-in-info"] }, /* @__PURE__ */ e.createElement("h5", null, I18n.t("booking_engine.room.check_in_info")), /* @__PURE__ */ e.createElement("p", null, l)) : null, /* @__PURE__ */ e.createElement("div", { className: n["guests-container"] }, /* @__PURE__ */ e.createElement(L, null), /* @__PURE__ */ e.createElement("span", { className: n.guests, "data-testid": "capacity-amount" }, I18n.t("booking_engine.information.capacity_amount_dot", {
    adults: i.toString(),
    children: s.toString()
  }))), /* @__PURE__ */ e.createElement("div", { className: n["rooms-container"] }, /* @__PURE__ */ e.createElement(O, null), /* @__PURE__ */ e.createElement("span", { className: n.rooms, "data-testid": "rooms-amount" }, a.length > 1 ? `${a.length} ${I18n.t("booking_engine.rooms")}` : ((k = a[0]) == null ? void 0 : k.roomName) ?? "")), /* @__PURE__ */ e.createElement(P, null));
}, X = ({
  cartItems: t,
  displaysInsideModal: a,
  canRemoveItem: i,
  children: s
}) => {
  const c = d(x), m = d(K), r = d(N), { hotelId: p, propertySize: l, propertyType: E, subscriptionPlan: g } = H(), { removeCartItem: h, removeCartItemWithoutConfirmation: k } = b();
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    U,
    {
      displaysInsideModal: a,
      cartItems: t,
      totalAdults: c,
      totalChildren: m,
      checkInTime: r.checkInTime,
      checkInEndTime: r.checkInEndTime,
      checkOutTime: r.checkOutTime,
      checkOutEndTime: r.checkOutEndTime,
      checkInInfo: r.checkInInfo,
      showCheckInCheckOutTime: r.showCheckInCheckOutTime
    }
  ), t.map((o, f) => {
    const v = !o.cityTaxIncluded && o.cityTaxes && {
      id: (/* @__PURE__ */ new Date()).getTime(),
      name: I18n.t("booking_engine.information.city_tax"),
      total_price: o.cityTaxes,
      amount: 0
    }, $ = [
      ...o.optionalExtras,
      ...o.mandatoryExtras,
      ...v ? [v] : []
    ];
    return /* @__PURE__ */ e.createElement(S, { key: o.id }, /* @__PURE__ */ e.createElement(I, { dataTestId: `room-name-${f}` }, /* @__PURE__ */ e.createElement("span", { className: n.room }, `${I18n.t("booking_engine.room")} ${f + 1}. `), o.roomName), /* @__PURE__ */ e.createElement(I, null, o.pricingTypeName), /* @__PURE__ */ e.createElement(y, { dataTestId: `room-price-${f}` }, /* @__PURE__ */ e.createElement("span", null, I18n.t("booking_engine.information.nights", {
      count: J(
        o.arrivalDate,
        o.departureDate
      ).toString()
    })), /* @__PURE__ */ e.createElement("span", null, _(
      parseFloat(o.totalPrice),
      r.currency
    ))), $.map((u, w) => /* @__PURE__ */ e.createElement(
      y,
      {
        key: u.id,
        dataTestId: `extra-name-${w}`
      },
      /* @__PURE__ */ e.createElement("span", null, u.amount ? `${u.amount} ${u.name}` : u.name),
      /* @__PURE__ */ e.createElement("span", null, _(
        parseFloat(u.total_price) * (u.amount || 1),
        r.currency
      ))
    )), i ? /* @__PURE__ */ e.createElement(
      A,
      {
        onClick: () => {
          Y(q.CLICK, j.CLICK_ON_DELETE, {
            hotel_id: p,
            property_type: E,
            property_size: l,
            subscription_plan: W(g)
          }), a ? k(o.id) : h(o.id);
        }
      }
    ) : null);
  }), s);
}, Z = ({ giftCards: t, displaysInsideModal: a, canRemoveItem: i, children: s }) => {
  const c = z(V), { removeGiftCard: m, removeGiftCardWithoutConfirmation: r } = b(), p = d(N).currency;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, a ? null : /* @__PURE__ */ e.createElement(D, { title: I18n.t("booking_engine.gift_card.purchase_header") }), t.map((l) => /* @__PURE__ */ e.createElement(S, { key: l.id }, /* @__PURE__ */ e.createElement(y, null, /* @__PURE__ */ e.createElement("span", null, l.name), /* @__PURE__ */ e.createElement("span", null, _(parseFloat(l.amount), p))), i ? /* @__PURE__ */ e.createElement(
    A,
    {
      onClick: () => {
        a ? r(l.id) : m(l.id), c(null);
      }
    }
  ) : null)), s);
}, _e = ({
  displaysInsideModal: t,
  customClasses: a,
  canRemoveItem: i = !0,
  children: s
}) => {
  const c = d(B), m = d(F);
  return !c.length && !m.length ? null : /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "booking-summary-content",
      className: Q(n["booking-summary-content"], a)
    },
    c.length ? /* @__PURE__ */ e.createElement(
      X,
      {
        cartItems: c,
        displaysInsideModal: t,
        canRemoveItem: i
      },
      s
    ) : null,
    m.length ? /* @__PURE__ */ e.createElement(
      Z,
      {
        giftCards: m,
        displaysInsideModal: t,
        canRemoveItem: i
      },
      s
    ) : null
  );
};
export {
  _e as BookingSummaryContent
};
